var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLabelP = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.33337,
    y: 1.33334,
    width: 13.3333,
    height: 13.3333,
    rx: 4,
    fill: "#FF6666"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.32483 4.79332C5.32483 4.25332 5.64631 3.89777 6.22075 3.89777H8.25334C9.94185 3.89777 11.1933 5.00036 11.1933 6.6422C11.1933 8.31887 9.89556 9.36405 8.3226 9.36405H7.04816V11.2474C7.04816 11.8218 6.68075 12.1429 6.18668 12.1429C5.69261 12.1429 5.3252 11.8218 5.3252 11.2474L5.32483 4.79332ZM7.04742 7.84813H8.21853C8.94223 7.84813 9.40149 7.31998 9.40149 6.63072C9.40149 5.94184 8.94223 5.41332 8.21853 5.41332H7.04742V7.84813Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLabelP);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_label_p.438954b8fc8aabd529ab913a2b95641a.svg";